import { useMemo } from 'react';
import { useAppDispatch } from '../app/redux/useAppSelector';
import InvitationModal from '../invitation/InvitationModal';
import { UIActions } from '../ui/uiSlice';

const useShowInvitationModal = () => {
  const dispatch = useAppDispatch();

  return useMemo(
    () => () => dispatch(UIActions.openModal(InvitationModal)),
    [dispatch],
  );
};

export default useShowInvitationModal;
